module.exports = __webpack_public_path__ + "img/hyxw.62aad5f3.png";